/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * Target billing customer for system admin billing operations. Exactly one of store_id, supplier_id, or retailer_id must be provided. Omit to use the current billing customer.
 * @export
 * @interface BillingCustomer
 */
export interface BillingCustomer {
    /**
     * 
     * @type {string}
     * @memberof BillingCustomer
     */
    storeId?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingCustomer
     */
    supplierId?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingCustomer
     */
    retailerId?: string;
}

/**
 * Check if a given object implements the BillingCustomer interface.
 */
// @ts-ignore
export function instanceOfBillingCustomer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function BillingCustomerFromJSON(json: any): BillingCustomer {
    return BillingCustomerFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingCustomer {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storeId': !exists(json, 'store_id') ? undefined : json['store_id'],
        'supplierId': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'retailerId': !exists(json, 'retailer_id') ? undefined : json['retailer_id'],
    };
}

// @ts-ignore
export function BillingCustomerToJSON(value?: BillingCustomer | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'store_id': value.storeId,
        'supplier_id': value.supplierId,
        'retailer_id': value.retailerId,
    };
}

